<template>
  <component class="Block-Project" :class="get_modify" :is="get_tag" :href="get_href" :target="get_blank">
    <AvatarImage class="Block-Project__icon" :src="props.image" :size="24" :radius="get_imgRadius" v-if="props.image" />
    <span class="Block-Project__name">{{ get_name }}</span>
    <span class="Block-Project__prefix" v-if="props.prefix">{{ props.prefix }}</span>
  </component>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  //------------------------------------------
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  //------------------------------------------
  const props = defineProps(Props());
  //------------------------------------------
  //Определить, блок является ссылкой?
  const get_tag = computed(() => props.link ? 'a' : 'span');
  //Определить класс модификатор
  const get_modify = computed(() => props.link ? 'Block-Project--link' : '');
  //Определить атрибут href
  const get_href = computed(() => props.link ? props.link : undefined );
  //Определить радиус картинки
  const get_imgRadius = computed(() => props.isSquare ? '4px' : '50%');
  //Переход по новой ссылке производить в новом окне
  const get_blank = computed(() => get_href.value ? '_blank' : undefined);
  //Получить имя проекта
  const get_name = computed(() => {
    if (props.name && props.name.length > 9) {
      return props.name.slice(0, 9) + '...';
    }
    return props.name;
  })
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
